import React from "react";

/**
 * Component to display No record in table
 * @param {*} props
 */
export default function(props) {
  if (!props.isFetching) {
    return (
      <tr>
        <td
          className="serial-pad"
          colSpan={props.colSpan || 3}
          rowSpan={props.rowSpan || 0}
        >
          {props.message || "No Records Found."}
        </td>
      </tr>
    );
  }
}
